import script from "./BannerMain.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerMain.vue?vue&type=script&setup=true&lang=js"

import "./BannerMain.vue?vue&type=style&index=0&id=1d7d4b19&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7d4b19"]])

export default __exports__